import { useCardTracking } from "@aviv-classified-card/card/full";
import { useThorEvent } from "@aviv-dxp/react-thor";
import { useTrackingEventsDatasNoItems } from "./useTracking";
export const useTrackingCardClick = (id) => {
    const tracking = useCardTracking(id);
    const thorEvent = useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        eventData: {
            event: "select_item",
            av_items: [tracking],
            ...useTrackingEventsDatasNoItems(),
            av_initiative: "wl_cdp",
        },
    });
    return () => thorEvent();
};
